import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiFieldSearch'
})
export class MultiFieldSearchPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    return this.filterItems(items, searchText);
  }

  private filterItems(items: any[], searchText: string): any[] {
    return items.filter(item => {
      const matchesInCurrentLevel =
        item.id.toString().includes(searchText) ||
        item?.subject.toLowerCase().includes(searchText);

      const matchesInChildLevels = item.children
        ? this.filterItems(item.children, searchText).length > 0
        : false;
      return matchesInCurrentLevel || matchesInChildLevels;
    });
  }

}
